import { useState } from "react";
import useLogin from "./useHook";
import "./style.css";

const LoginPage = ({ onLoginSuccess }) => {
  const { loginUser } = useLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    const body = {
      email,
      password,
    };
    await loginUser(body);
    onLoginSuccess();
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="auth-main-layout">
      <div className="auth-glass-box">
        <form onSubmit={handleLogin}>
          <h1>Welcome</h1>
          <h2 className="auth-centered-text">Access your account</h2>
          <div className="auth-field-wrapper">
            <input
              type="text"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <i className="bx bxs-user"></i>
          </div>
          <div className="auth-field-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <i
              className={`bx ${showPassword ? "bxs-show" : "bxs-hide"}`}
              onClick={togglePasswordVisibility}
              style={{ cursor: "pointer" }}
            ></i>
          </div>
          <div className="auth-meta-options">
            <label>
              <input type="checkbox" />
              Remember me
            </label>
            <a href="/forgot-password">Forgot Password?</a>
          </div>
          <button type="submit" className="auth-login-action">
            Log in
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
